<ng-template #content let-modal>
  <div class="modal-header" style="  background: linear-gradient(to bottom, #F9F9FC 0%, #EEEEF4 100%);    height: 50px;
  width: 760;">
    <h4 style="font-size: 16px; font-weight: 500;" class="modal-title ml-0">Support</h4>
    <button type="button"  aria-label="Close" class="button-close" (click)="closeModal()" style="border: none;background: linear-gradient(to bottom, #F9F9FC 0%, #EEEEF4 100%);">
      <span aria-hidden="true" style="    font-size: 30px;">
        &times;
      </span> </button>
  </div>
  <div class="modal-body px-2 py-4 text-center">
    <div style="    height: 5px;">
      <!-- <p *ngIf="eSupportText" class="text-left px-3" id="eSupportText" [ngStyle]="{ color: color }"> {{ eSupportText }}
      </p> -->
      <p *ngIf="eSupportText" class="text-left px-3" id="eSupportText" [ngStyle]="{ color: color }">
        <i *ngIf="color === 'green'" class="fas fa-check-circle me-1"></i>
        <i *ngIf="color === 'red'" class="fa fa-times-circle me-1"></i>
        {{ eSupportText }}
      </p>
    </div>
    <form style="margin-top: 10px">
      <div class="">
        <div class="col-6 float-left pr-2 mt-3">
          <input id="name" type="text" name="form_subject" ngDefaultControl ngModelOptions class="form-control" required
            [value]="getFullName()" readonly placeholder="Name" style="background-color: #F4F4F9"
            onfocus="this.placeholder=''" onblur="this.placeholder='Name'" />
          <!-- value="{{ firstName }} {{ lastName }}" -->
        </div>
        <div class="col-6 float-left pl-2 mt-3">
          <input id="email" type="text" name="form_subject" ngDefaultControl ngModelOptions class="form-control"
            readonly required value="{{ emailAddress }}" placeholder="Email" onfocus="this.placeholder=''"
            style="background-color: #F4F4F9" onblur="this.placeholder='Email'" />
        </div>
        <div class="col-12 float-left mt-3">
          <input type="text" name="form_subject" ngDefaultControl class="form-control" required value=""
            id="form_subject" name="form_subject" placeholder="Subject" onfocus="this.placeholder=''"
            onblur="this.placeholder='Subject *'" />
        </div>
        <div class="col-12 float-left  mt-3">
          <div class="form-group m-0">
            <textarea id="form_message" name="form_message" ngDefaultControl class="form-control"
              placeholder="Message *" onfocus="this.placeholder=''" onblur="this.placeholder='Message *'" rows="6"
              style="resize: none; height: 220px !important"> </textarea>
            <p class="float-right mt-2" style="font-size: 14px;
            font-weight: 400;
            line-height: 16.94px;
            text-align: left;"> {{ matchfirst }}{{ matchlast }} Web Version 1.0.0 </p>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-12 p-2" id="supportSaveMsg" style="display: none;"><img style="" src="assets/images/ajax-loader1.gif"></div> -->
    </form>
    <div class="col-12 float-left py-2">
      <button type="button" *ngIf="testingval == '0' || testingval == '1'" data-dismiss="modal"
        class="btn btn-modal-dark float-left mr-2" id="quick_tour" data-toggle="modal"
        data-target="#tooltiphomeButtonModal"> Start Tour </button>
      <a routerLink="/help-center" data-dismiss="modal" (click)="navigatetohelpcenter()">
        <button type="button" class="btn btn-modal-dark float-left faq"> Go to FAQ's </button>
      </a>
      <input type="submit" class="btn btn-modal-dark m-0 float-right suport-submit" value="Submit"
        (click)="supportSubmission()" />
    </div>
  </div>
  
</ng-template>
<button class="btn btn-lg btn-outline-primary d-none" (click)="openModels(content)"> support </button>
